module.exports = __webpack_public_path__ + "static/media/sample_mll_last_mile_batch.82d186c9.csv";